import request from "../../../../../base/request";

const urlMap = {
    picture:"/search-server/search/getList/picture/dept",
    video:"/search-server/search/getList/video/dept",
    audio:"/search-server/search/getList/audio/dept",
};

const loadList = ({indexName,start,size,search,other})=>{
    return new Promise((resolve, reject) => {
        request({
            url: urlMap[indexName],
            contentType:"json",
            method:"post",
            body:{ pageNum:start,pageSize:size,keyword:search,...other },
            callBack:(data)=>{
                console.log(data.count)
                data&& data.data && data.data.map(item=>{
                    item.component = require(`../${indexName}/${indexName}`).default;
                });
                resolve(data);
            }
        })
    })
};
export default loadList;